import { KeyboardEvent, RefObject } from 'react';

type InputRefs = {
    [key: string]: RefObject<HTMLInputElement | HTMLTextAreaElement> | undefined;
};

export const keyController = (e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>, id: string, refs: InputRefs) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        switch (id) {
            case 'patientName':
                refs.yearInputRef?.current?.focus();
                break;
            case 'birthDay':
                refs.genderInputRef?.current?.focus();
                break;
            case 'gender':
                refs.schoolAgeInputRef?.current?.focus();
                break;
        }
    }
};
